// Getters del módulo Taxonomy.
// getExpendioNombrePorCodigo: resuelve el nombre por código de expendio desde el cache.
// Devuelve null si no existe para que la UI decida el fallback (mostrar advertencia, usar código "02", etc.).
const getters = {
  getExpendioNombrePorCodigo: (state) => (codigo) => {
    if (!codigo) return null;
    return state.expendiosByCodigo[codigo] || null;
  },
};

export default getters;
